import { useVisible } from '@vev/hooks';

export function LazyLoadWrapper({
  children,
  hostRef,
}: {
  children: React.ReactNode;
  hostRef: React.RefObject<HTMLDivElement>;
}) {
  const visible = useVisible(hostRef, {
    offsetBottom: -window.innerHeight,
    offsetTop: -window.innerHeight,
  });

  return visible ? children : null;
}
